import { useParams } from 'react-router-dom';
import ErrorWrapper from '@/components/content/error/ErrorWrapper';
import { ticketErrors } from '@/client/features/issue/utils/errors';
import IssuePlaceholder from '@/client/features/issue/components/IssuePlaceholder';
import IssueTitle from '@/client/features/issue/components/IssueTitle';
import IssueWrapperV2 from '@/client/features/issue/components/IssueWrapper';
import { Group } from '@mantine/core';
import JSONEditTrigger from '@/client/features/signals/components/JSONEditTrigger';
import RequestIntelligence from '@/client/features/mailboxes/RequestIntelligence';
import { useEventEntity } from '@/client/features/events/services/events';
import { left, right } from '@/client/features/events/configs/event.entitymodules';

const EventView = () => {
  const { entity } = useParams();
  const entityId = entity as string;

  const query = useEventEntity(entityId);

  return (
    <ErrorWrapper
      isError={query.isError}
      refetch={query.refetch}
      error={query.error}
      errors={ticketErrors}
      canUpsell
    >
      <IssuePlaceholder isLoading={query.isPending}>
        <IssueTitle docTitle="Event" title={query.data?.title} />

        <IssueWrapperV2
          left={left}
          right={right}
          id={entityId}
          data={{ ...query.data } as any}
          actions={
            <Group gap={10} align="center" justify="center" className="noPrint">
              <JSONEditTrigger json={(query.data as any)?.raw} filename={`event-${entityId}`} />
              <RequestIntelligence ticketId={entityId} iconOnly />
            </Group>
          }
        />
      </IssuePlaceholder>
    </ErrorWrapper>
  );
};

export default EventView;
